var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.withdraw == 'pay')?[_c('paymentForm'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"mt-2"},[_vm._v("Güncel Papara hesaplarımızı lütfen Canlı Destek üzerinden isteyiniz.")])]:_vm._e(),_vm._v(" "),(_vm.$route.params.withdraw == 'withdraw')?[_c('withdrawForm')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5d3b342","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/gateways/extend.vue
// module id = Vkhf
// module chunks = 0